import React from 'react';

const gameStyles = {
  'D&D': 'dnd',
  'Chess': 'chess',
  'Catan': 'catan',
  'Magic: The Gathering': 'mtg',
  'Pokemon': 'pokemon',
  'Yu-Gi-Oh!': 'yugioh',
  'Warhammer': 'other',
  'Monopoly': 'chess',
  'Ticket to Ride': 'catan',
  'Scrabble': 'chess',
  'Risk': 'yugioh',
  'Other': 'other'
};

export default function GamePill({ game, selected, onClick, small }) {
  const styleClass = gameStyles[game] || 'other';
  
  return (
    <button
      onClick={onClick}
      className={`game-pill ${styleClass} ${selected ? 'ring-2 ring-white/30' : ''} ${small ? 'text-[10px] py-1 px-2' : ''}`}
      data-testid={`game-pill-${game.toLowerCase().replace(/[^a-z0-9]/g, '-')}`}
    >
      {game}
    </button>
  );
}
